import { getSportingServiceURL } from 'services/sporting/utils/getSportingURL';
import { customFetch } from 'utils/customFetch';
import { UnexpectedError } from 'utils/errors';
import {
  SportingSecureParams,
  TSportingCompetitionParticipantStatusId
} from 'services/sporting/types';
import { createQueryString } from 'utils/createQueryString';
import { createSportingHeaders } from 'services/sporting/utils/createSportingHeaders';

type Payload = {
  idParticipation: number;
  idStatus: TSportingCompetitionParticipantStatusId;
};

export const changeParticipationStatus = async (
  params: SportingSecureParams<Payload>
): Promise<void> => {
  const { payload } = params;

  const headers = createSportingHeaders();

  const endpointURL = getSportingServiceURL(
    `changeParticipationStatus?${createQueryString(payload)}`
  );

  const response = await customFetch(endpointURL, {
    method: 'POST',
    headers
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }
};
